/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import { useNitroStore } from "../store/Store";
import PickerOption from "./PickerOption";

const ProductPicker = ({
  value,
  setValue,
}: {
  value: string;
  setValue: (value: string) => void;
}) => {
  const [priorityProducts] = useNitroStore((state) => [state.priorityProducts]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: 10,
        flexWrap: "wrap",
      }}
    >
      <PickerOption
        width={90}
        height={46}
        label="All"
        select={() => setValue("")}
        selected={!value}
      />
      {priorityProducts.map((p) => (
        <PickerOption
          key={p}
          width={90}
          height={46}
          label={p}
          select={() => setValue(p)}
          selected={value === p}
        />
      ))}
    </div>
  );
};

export default ProductPicker;
